<h4 mat-dialog-title>Ajouter un utilisateur</h4>
<mat-dialog-content style="min-height: 80px;">
  <form [formGroup]="firstFormGroup">
    <div class="form-group {{(!email.valid && email.errors !== null) ? 'form-error' : ''}}">
      <label for="email">Email<span class="star">*</span> : </label>
      <input class="form-control"  name="email" formControlName="email" id="email" type="email" placeholder="Email"
        required>
        <app-controls-messages [control]="email"></app-controls-messages>
      </div>
      <div class="form-group">
        <label for="nom">Nom<span class="star">*</span> : </label>
        <input class="form-control" id="nom" placeholder="Nom" formControlName="nom" required>
        @if (nom.invalid && (nom.dirty || nom.touched)) {
          <div class="alert alert-danger">
            @if (nom.errors.required) {
              <div>
                Le nom est requis.
              </div>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label for="prenom">Prenom<span class="star">*</span> : </label>
        <input class="form-control" id="prenom" placeholder="Prenom" formControlName="prenom" required>
        @if (prenom.invalid && (prenom.dirty || prenom.touched)) {
          <div class="alert alert-danger">
            @if (prenom.errors.required) {
              <div>
                Le prenom est requis.
              </div>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <fieldset class="form-group">
          <label for="locale">Langue utilisateur<span class="star">*</span> : </label>
          <mat-select class="form-control" formControlName="locale" id="locale" required>
            <mat-option value="fr">Français</mat-option>
            <mat-option value="en">Anglais</mat-option>
          </mat-select>
        </fieldset>
        @if (locale.invalid && (locale.dirty || locale.touched)) {
          <div class="alert alert-danger">
            @if (locale.errors.required) {
              <div>
                La langue est requise.
              </div>
            }
          </div>
        }
      </div>
    </form>
    <div class="form-group">
      <p>Rôle<span class="star">*</span> : </p>
      @for (role of roles; track role; let i = $index) {
        <div>
          <div [hidden]="role.label === 'Président / Vice-président' || role.label === 'Candidat / porteur'">
            <mat-checkbox id="role-{{i}}" style="width:200px;" [(ngModel)]="role.checked">{{role.label}}
            </mat-checkbox>
          </div>
        </div>
      }
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Annuler</button>
    <button mat-raised-button color="primary" type="submit" (click)="addUser()">Ajouter</button>
  </mat-dialog-actions>
